module.exports = __webpack_public_path__ + "img/指上.eac0a53a.png";